import type { InternalCalibrationArea } from '@ulysses-inc/harami_api_client'
import { useForm, useWatch } from 'react-hook-form'
import {
  CALIBRATION_AREA_FORM_DEFAULT_VALUES,
  type CalibrationAreaFormValues,
} from './formValues'

type Input = {
  calibrationArea?: InternalCalibrationArea
  saveCalibrationArea: (ca: InternalCalibrationArea) => void
  onClose: () => void
}

export const useCalibrationAreaForm = ({
  calibrationArea,
  saveCalibrationArea,
  onClose,
}: Input) => {
  const initialValue: CalibrationAreaFormValues = calibrationArea || {
    ...CALIBRATION_AREA_FORM_DEFAULT_VALUES,
    id: crypto.randomUUID(),
  }

  const { control, setValue } = useForm<CalibrationAreaFormValues>({
    defaultValues: initialValue,
  })

  // watch() は React Compiler と非互換のため、useWatch を使用する。
  // useWatch の戻り型は DeepPartialSkipArrayKey<T>（全フィールドが optional）だが、
  // defaultValues を必ず渡しているためランタイムでは常に完全な値が保証される。
  const formValues = useWatch({ control }) as CalibrationAreaFormValues

  const canSubmit = !(
    formValues.width === 0 &&
    formValues.height === 0 &&
    formValues.x === 0 &&
    formValues.y === 0
  )

  const handleSave = () => {
    if (!canSubmit) return
    saveCalibrationArea({
      id: formValues.id,
      x: formValues.x,
      y: formValues.y,
      width: formValues.width,
      height: formValues.height,
    })
    onClose()
  }

  return { formValues, setValue, canSubmit, handleSave }
}
